import {
  WheelSvg,
  ChangeVehicleSvg,
  ServiceSvg,
  ConditioningSvg,
  TireBalancingSvg,
  DiagnosisSvg,
  MaintenanceWarrantySvg,
  RustSvg,
  HeaterSvg,
  EmissionSvg,
  BatterySvg,
  OilChangeSvg,
  EngineSvg,
  CoolingSvg,
  SuspensionSvg,
  BrakesSvg,
  FuelSvg,
  ExhaustPipeSvg,
  TransmissionSvg,
  WarrantySvg,
} from 'assets/svg/service-icons';
import { redColors } from 'theme/colors';

import type { ReactNode } from 'react';

interface Service {
  id: number;
  title: string;
  component: ReactNode;
}

export const services: Service[] = [
  {
    id: 0,
    title: 'Rengasmyynti ja Rengashotelli, kausisäilytys',
    component: <WheelSvg fill={redColors.light} />,
  },
  {
    id: 1,
    title: 'Sijaisautot huollon tai korjauksen ajaksi',
    component: <ChangeVehicleSvg fill={redColors.light} />,
  },
  {
    id: 2,
    title: 'Henkilö- ja pakettiautojen kaikki huollot ja korjaukset',
    component: <ServiceSvg fill={redColors.light} />,
  },
  {
    id: 3,
    title: 'Ilmastointi huolto ja korjaus',
    component: <ConditioningSvg fill={redColors.light} />,
  },
  {
    id: 4,
    title: 'Renkaiden tasapainotus ja 3D-suuntaus',
    component: <TireBalancingSvg fill={redColors.light} />,
  },
  {
    id: 5,
    title: 'Vikadiagnostiikka ja raportointi',
    component: <DiagnosisSvg fill={redColors.light} />,
  },
  {
    id: 6,
    title: 'Määräaikaishuollot – Autosi takuu säilyy',
    component: <MaintenanceWarrantySvg fill={redColors.light} />,
  },
  {
    id: 7,
    title: 'Ruostevauriokorjaukset',
    component: <RustSvg fill={redColors.light} />,
  },
  {
    id: 8,
    title: 'Sisätilalämmittimet',
    component: <HeaterSvg fill={redColors.light} />,
  },
  {
    id: 9,
    title: 'Päästömittaukset ja diagnostiikat',
    component: <EmissionSvg fill={redColors.light} />,
  },
  {
    id: 10,
    title: 'Henkilöauton ja pakettiauton käynnistimet, akut, laturit',
    component: <BatterySvg fill={redColors.light} />,
  },
  {
    id: 11,
    title: 'Öljynvaihdot',
    component: <OilChangeSvg fill={redColors.light} />,
  },
  {
    id: 12,
    title: 'Jakopään huollot ja korjaukset',
    component: <EngineSvg fill={redColors.light} />,
  },
  {
    id: 13,
    title: 'Jäähdytysjärjestelmän huollot ja korjaukset',
    component: <CoolingSvg fill={redColors.light} />,
  },
  {
    id: 14,
    title: 'Ohjaus- ja jousitustyöt',
    component: <SuspensionSvg fill={redColors.light} />,
  },
  {
    id: 15,
    title: 'Jarrujen huollot ja korjaukset',
    component: <BrakesSvg fill={redColors.light} />,
  },
  {
    id: 16,
    title: 'Polttoainejärjestelmien huollot sekä korjaukset',
    component: <FuelSvg fill={redColors.light} />,
  },
  {
    id: 17,
    title: 'Pakokaasujärjestelmien korjaustyöt',
    component: <ExhaustPipeSvg fill={redColors.light} />,
  },
  {
    id: 18,
    title: 'Voimansiirron huollot ja korjaukset',
    component: <TransmissionSvg fill={redColors.light} />,
  },
  {
    id: 19,
    title: 'Takuu: 12kk tai 15000km',
    component: <WarrantySvg fill={redColors.light} />,
  },
];
